import { Button } from '@/components/ui/button'
import { TvMinimalPlay } from 'lucide-react'
import { useCallback, useEffect } from 'react'
import { GUNSLINGER_JOB_STATUSES, ITERATION_COMMANDS } from '@/const/const'
import { useUserCommandFlowUntilCondition } from '@/lib/iterations/useUserCommandFlowUntilCondition.ts'

export function RunProjectButton({
  iterationId,
  onLoadingChange,
}: {
  iterationId: string
  onLoadingChange?: (isLoading: boolean) => void
}) {
  const { sendCommandMutation, isLoadingUserCommand } = useUserCommandFlowUntilCondition(
    iterationId,
    iteration => {
      if (!iteration) {
        return false
      }
      return [GUNSLINGER_JOB_STATUSES.RUNNING, GUNSLINGER_JOB_STATUSES.ERROR].includes(
        iteration.vmStatus
      )
    }
  )

  const handleLoadingChange = useCallback(
    (isLoading: boolean) => {
      onLoadingChange?.(isLoading)
    },
    [onLoadingChange]
  )

  useEffect(() => {
    handleLoadingChange(isLoadingUserCommand)
  }, [isLoadingUserCommand, handleLoadingChange])

  const resumeIteration = useCallback(async () => {
    sendCommandMutation.mutate({ command: ITERATION_COMMANDS.REVIVE })
  }, [sendCommandMutation])

  return (
    <Button variant="default" onClick={resumeIteration} disabled={isLoadingUserCommand}>
      <TvMinimalPlay />
      {isLoadingUserCommand ? 'Running Project...' : 'Run Project'}
    </Button>
  )
}
